function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_x0020_1"
}, /*#__PURE__*/React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1387 468c-51,11 -129,40 -179,64 -180,87 -100,4 -479,-219l-418 413c58,97 146,213 213,302 100,130 23,67 -56,359l-462 76 -6 592 468 76c135,489 195,76 -155,660l415 418c355,-213 309,-307 471,-228 50,25 132,58 190,70l76 461 592 7 77 -467c65,-19 118,-37 179,-66 178,-85 99,-9 480,220l419 -413c-223,-367 -308,-310 -227,-471 27,-59 54,-125 69,-191l461 -76 7 -592 -468 -77c-18,-65 -36,-118 -66,-179 -44,-92 -58,-91 3,-171 68,-89 160,-210 218,-308l-413 -418c-99,59 -213,147 -303,214 -128,97 -75,21 -360,-56l-76 -462 -586 -6 -84 468 0 0zm275 418c-449,53 -838,458 -776,976 53,445 464,832 979,771 445,-53 832,-463 771,-978 -53,-443 -464,-831 -974,-769l0 0zm-383 1337c78,-84 -8,-29 199,-231 -66,-127 -126,-233 -37,-401 50,-95 166,-194 321,-194 153,0 269,99 319,194 89,169 29,272 -37,401 36,34 77,71 110,104 38,42 53,90 88,127 422,-408 110,-1136 -480,-1136 -591,0 -905,730 -483,1136zm181 139c205,92 395,95 602,0 -63,-318 -539,-318 -602,0zm245 -745c-187,72 -92,359 116,285 173,-60 92,-365 -116,-285z"
}));

var SvgCustomeradministration = function SvgCustomeradministration(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 3522 3519",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCustomeradministration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/customeradministration.7bd9d166.svg";
export { ForwardRef as ReactComponent };